import post from './methodPost';
import get from './methodGet';

export default { ...post, ...get };
